<template>
    <q-footer bordered class="bg-background text-on-background q-px-sm-md q-px-xs-sm">
        <div class="row items-center q-py-lg page-container">
            <div class="text-bold q-pr-lg">{{ $t('app.url') }}</div>
            <div>{{ $t('app.short-name') }}</div>
        </div>
    </q-footer>
</template>
